import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'cvpc-relatesto-radiobutton',
  styles: [`
    /* Common styles */
    label.checked {
      border-width: 2.5px;
      color: #fff !important;
      font-weight: 600;
    }
    .my-wrapper label.unchecked {
      border: 0;
      background: #EDF5F5;
    }
    .add_action_div label.unchecked {
      border: 2px solid #3CB4AA;
    }
    label.action_unchecked {
      border: 2px solid #D9D9D9;
    }

    .radio_blk {
      display: none;
    }

    /* Default text colors */
    span.checked {
      color: #fff;
      font-weight: 600;
    }
    span.unchecked {
      color: #3CB4AA;
      font-weight: 600;
    }
    span.action_unchecked {
      color: #000000;
    }

    .my-wrapper {
      height: 50px;
      padding: 0;
      background: #EDF5F5;
      border-radius: 20px;
    }
    .action_sub_blk {
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      justify-content: space-evenly;
      width: 100%;
      height: 40px;
    }
    .my-wrapper .option {
      margin-right: 0 !important;
      border-radius: 20px;
      padding: 6px 20px;
      cursor: pointer;
      transition: all 0.3s;
    }
    .priority {
      color: #000000;
      font-size: 12px;
    }
    .priority_mandatory {
      font-size: 12px;
    }

    /* ✅ Different background colors for selected options */
    label.checked.low {
      background: #FFFBE8; /* Red */
      border-color: #CCA105;
    }
    label.checked.medium {
      background: #FFEEDA; /* Orange */
      border-color: #DD7601;
    }
    label.checked.high {
      background: #FFEEEE; /* Teal */
      border-color: #EF0015;
    }
    label.checked.urgent {
      background: #FFACAC; /* Light Blue */
      border-color: #9F0014;
    }
  `],
  template: `
    <!-- Case 1 -->
    <div class="wrapper my-wrapper" *ngIf="to.myoptions && to.source=='VPC_ADD' && !to.disabled">
      <div class="sub_blk" *ngFor="let option of to.myoptions; let i = index" (change)="onChange(option.value)">
        <input type="radio" name="{{to.name}}" id="{{option.value}}" class="radio_blk" 
          [checked]="option.value == formControl.value" [disabled]="to.disabled">

        <label for="{{option.value}}" class="option"
          [ngClass]="{
            'checked': option.value == formControl.value,
            'unchecked': option.value != formControl.value,
            'urgent': option.value.toLowerCase() === 'urgent',
            'high': option.value.toLowerCase() === 'high',
            'medium': option.value.toLowerCase() === 'medium',
            'low': option.value.toLowerCase() === 'low'
          }">
          <span [ngClass]="{
            'checked': option.value == formControl.value,
            'unchecked': option.value != formControl.value
          }">{{option.label | translate}}</span>
        </label>
      </div>
    </div>

    <!-- Case 2 -->
    <div *ngIf="to.myoptions && to.source=='ADD_ACTION'" class="priority">
      Priority <span class="priority_mandatory">*</span>
    </div>
    <div class="wrapper add_action_div" *ngIf="to.myoptions && to.source=='ADD_ACTION'">
      <div class="action_sub_blk" *ngFor="let option of to.myoptions; let i = index" (change)="onChange(option.value)">
        <input type="radio" name="{{to.name}}" id="{{option.value}}" class="radio_blk" 
          [checked]="option.value == formControl.value" [disabled]="option.disabled">

        <label for="{{option.value}}" class="option"
          [ngClass]="{
            'checked': option.value == formControl.value,
            'action_unchecked': option.value != formControl.value,
            'urgent': option.value.toLowerCase() === 'urgent',
            'high': option.value.toLowerCase() === 'high',
            'medium': option.value.toLowerCase() === 'medium',
            'low': option.value.toLowerCase() === 'low'
          }">
          <span [ngClass]="{
            'checked': option.value == formControl.value,
            'action_unchecked': option.value != formControl.value
          }">{{option.label | translate}}</span>
        </label>
      </div>
    </div>
  `,
  standalone: false
})
export class CvpcRelatestoFormlyType extends FieldType {
  isSelected: any;
  previousValue: string = '';

  ngOnInit() {
    this.isSelected = this.to.defaultset;
  }

  onChange(option: any) {
    this.formControl.patchValue(option);
    this.formControl.markAsTouched();
  }
}
